module.exports = __webpack_public_path__ + "static/media/suvLight.95705cef.svg";